import React from 'react'

export const IconFavorites = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M18.625 13.92c2.817-2.926 2.36-6.08.786-7.6-1.572-1.521-4.42-1.983-6.29 0-.29.213-.57.595-.787.76-.221-.165-.5-.547-.786-.76-1.875-1.958-4.719-1.521-6.292 0-1.572 1.52-2.033 4.674.787 7.6l6.29 6.08c.1 0 6.292-6.08 6.292-6.08z"
        stroke="currentColor"
        strokeWidth={1}
        fill="#fff"
        strokeLinecap="round"
      />
    </svg>
  )
}
